import { createI18n } from 'vue-i18n';
import en from './en-US';
import cn from './zh-CN';
import cnHK from './zh-HK';

export const LOCALE_OPTIONS = [
    { label: '中文', value: 'zh-CN' },
    { label: '中文-繁體', value: 'zh-HK' },
    { label: 'English', value: 'en-US' },
];
// 提取为独立函数：获取保存的语言
export function getSavedLocale(): string {
    const saved = localStorage.getItem('enric-locale');
    if (saved && LOCALE_OPTIONS.some(opt => opt.value === saved)) {
        return saved;
    }
    // 兜底逻辑
    const browserLang = navigator.language;
    if (browserLang.startsWith('zh-TW') || browserLang.startsWith('zh-HK')) {
        return 'zh-HK';
    } else if (browserLang.startsWith('zh')) {
        return 'zh-CN';
    } else {
        return 'en-US';
    }
}

// 设置 HTML lang 属性
export function setHtmlLang(lang: string) {
    document.documentElement.lang = lang;
}

// 保存语言
export function saveLocale(lang: string) {
    localStorage.setItem('enric-locale', lang);
}
// 获取初始语言
//const defaultLocale = localStorage.getItem('enric-locale') || 'zh-CN';
const defaultLocale =getSavedLocale();
//console.warn(cn);
const i18n = createI18n({
    locale: defaultLocale,
    fallbackLocale: 'zh-CN',
    legacy: false,
    allowComposition: true,
    messages: {
        'en-US': en,
        'zh-CN': cn,
        'zh-HK': cnHK,
    },
});
//初始设置 lang 属性
setHtmlLang(defaultLocale);

export default i18n;
